/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashledger_Remitted1Inputs */

const vi_cashledger_remitted1 = /** @type {(inputs: Cashledger_Remitted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nộp`)
};

/**

* @param {Cashledger_Remitted1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cashledger_remitted1 = /** @type {((inputs?: Cashledger_Remitted1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashledger_Remitted1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashledger_remitted1(inputs)
});
export { cashledger_remitted1 as "cashLedger_remitted" }